export const DASHBOARD_MODAL = 'DASHBOARD_MODAL';
export const DEPENDANT_QUERIES_MODAL = 'DEPENDANT_QUERIES_MODAL';
export const JOIN_MODAL = 'JOIN_MODAL';
export const SAVE_MODAL = 'SAVE_MODAL';

export const DASHBOARD_WIDGET_CONFIGURATION = 'DASHBOARD_WIDGET_CONFIGURATION';

export const START_FROM_SAVED_QUERY_DROPDOWN =
  'START_FROM_SAVED_QUERY_DROPDOWN';
